import { z } from 'zod';

export const CartItemSchema = z.object({
    type: z.enum([
        'delivery',
        'culinary-studio',
        'outdoor-bars',
        'sweet-shop',
        'cake-to-order',
    ]),
    uid: z.string(),
    portionIndex: z.number().optional(),
    count: z.number(),
});

export type ICartItem = z.infer<typeof CartItemSchema>;
